var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/calendar-"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2 2.5H4.8c-.45 0-.8.35-.8.8V6h19V3.3c0-.45-.35-.8-.8-.8z",
    className: "secondarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2 20.5H4.8a.79.79 0 0 1-.8-.8V9h19v10.7c0 .45-.35.8-.8.8z",
    className: "tertiarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3h-3v-.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5V3H8v-.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5V3H4c-.95 0-2 1.05-2 2v15.25C2 21.2 2.8 22 3.75 22h16.5c.95 0 1.75-.8 1.75-1.75V5c0-.95-1.05-2-2-2zm1 17.25c0 .4-.35.75-.75.75H3.75c-.4 0-.75-.35-.75-.75V8h18v12.25zM3 7V5c0-.4.6-1 1-1h3v.5c0 .3.2.5.5.5s.5-.2.5-.5V4h8v.5c0 .3.2.5.5.5s.5-.2.5-.5V4h3c.4 0 1 .6 1 1v2H3zm3 11v-.55l3.2-3.85c.3-.4.55-.8.55-1.2 0-.65-.55-1.15-1.3-1.15-.65 0-1.25.45-1.35 1.2l-1.15-.2c.2-1.35 1.25-2.15 2.55-2.15 1.4 0 2.5.95 2.5 2.35 0 .75-.35 1.45-.85 2-.95 1.05-1.1 1.3-2.1 2.4H11V18H6zm8.85-8c2.25 0 2.85 1.8 2.85 4.05 0 2.2-.6 4-2.85 4s-2.85-1.8-2.85-4S12.6 10 14.85 10zm0 6.9c1.3 0 1.65-1.25 1.65-2.8 0-1.55-.35-2.8-1.65-2.8-1.3 0-1.65 1.25-1.65 2.8 0 1.5.35 2.8 1.65 2.8z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fb53587f398cf6d61d59c0e5e71b8357.svg";
export { ForwardRef as ReactComponent };